import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import ProjectCard from '../../components/ProjectCard';
import useProjects from '../../hooks/useProjects';
import { Helmet } from 'react-helmet';

const Completed = () => {
  const { allProjects } = useProjects();

  return (
    <div style={{ padding: '4rem 0 8rem 0' }}>
      <Helmet>
        <title>Completed Projects | Solaric</title>
      </Helmet>
      <Breadcrumb current='Completed Projects' previous='projects' />
      <div className='row header-title text-center' id='completed'>
        <div className='col-md-8 col-lg-6 mx-auto' style={{ marginTop: '-3rem' }}>
          <h2>Completed Projects</h2>
        </div>
      </div>
      <div className='row mx-auto mb-5 p-5 projectContainer'>
        {allProjects.map((project) => {
          if (project?.type === 'completed')
            return (
              <div className='col-sm-6 col-md-4 col-lg-3' key={project.id}>
                <ProjectCard project={project} />
              </div>
            );
        })}
      </div>
    </div>
  );
};

export default Completed;
